module.exports = __webpack_public_path__ + "static/media/delete.7962e606.svg";